import React from "react";

export default function CulmoraMark({ className = "w-8 h-8", title = "Culmora" }) {
  return (
    <svg viewBox="0 0 64 64" role="img" aria-label={title} className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="culmora-metal" x1="10" y1="8" x2="52" y2="56" gradientUnits="userSpaceOnUse">
          <stop stopColor="#F5F7F8" />
          <stop offset="0.35" stopColor="#90979D" />
          <stop offset="0.7" stopColor="#F3F4F5" />
          <stop offset="1" stopColor="#5D6368" />
        </linearGradient>
        <linearGradient id="culmora-peak" x1="18" y1="45" x2="47" y2="27" gradientUnits="userSpaceOnUse">
          <stop stopColor="#72787D" />
          <stop offset="0.55" stopColor="#F7F8F8" />
          <stop offset="1" stopColor="#8D9499" />
        </linearGradient>
      </defs>
      <path d="M49.5 17.6A23 23 0 1 0 51 45.2" stroke="url(#culmora-metal)" strokeWidth="7" strokeLinecap="round" />
      <path d="M15 49L28.3 34.5L34 40.2L39.5 31L51 46" stroke="url(#culmora-peak)" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13 50.5C24.5 52.5 38.5 52.8 52.5 47.3" stroke="#20D4D9" strokeOpacity="0.55" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
